import Sonda from "@gcloud-npm/utils.monitoring.sonda";
import getUUID from "@gcloud-npm/utils.monitoring.get-uuid";
import Request from "@/utils/fetch";
import {
  makeUpTelcoPathName,
  getAdabyronConstants,
  PROCESS_NAME,
} from "@gcloud-npm/utils.adabyron.make-up-telco-path-name";
import { calculateHeaderParams } from "@gcloud-npm/node.build-process.build-environments";
import { FAMILY_API } from "@gcloud-npm/utils.enums.environment";
import sendToRelogin from '@gcloud-npm/utils.page.send-to-relogin';
import  {hasSecureEsimPending} from "@/utils/utils"

const PATH = "productos/misproductos/";
const EVENT_NAME = "PRODUCTS.MY_PRODUCTS";
const METHOD = "GET";
const CACHE_PARAM="status"
const CACHE_VALUE="2"

export const getMyProducts = ({
  data,
  version,
  context,
  idFront = "TC",
  build = false,
  onRedirect,
}) => {
  const { environment, userType } = context;
  const { telco: connectionData } = environment;
  const { endpoint: host } = connectionData;
  const { catalogSubSections, withoutCache } = data;

  const idRequest = getUUID(idFront);
  const headers2Use = calculateHeaderParams(build, FAMILY_API.TELCO, context);
  const { prefixToApply } = getAdabyronConstants(userType);

  const sonda = new Sonda({
    eventName: EVENT_NAME,
    context,
    uniqueId: idRequest,
    origin: PROCESS_NAME.CLIENT,
  });

  const hasSecureEsimPendingCalc = hasSecureEsimPending();
  let queryParams = [];
  if(hasSecureEsimPendingCalc){
    queryParams.push({ param: CACHE_PARAM, value: CACHE_VALUE });
  }
  queryParams.push({
    param: "subsecciones",
    value:
      Array.isArray(catalogSubSections) && catalogSubSections.length > 0
        ? catalogSubSections.toString()
        : "",
  });
  withoutCache &&
    queryParams.push({
      param: "nocache",
    });

  let urlParamsToReplace = [];

  const URL_API = makeUpTelcoPathName({
    path: PATH,
    version,
    idRequest,
    host,
    prefixToApply,
    queryParams,
    urlParamsToReplace,
  });

  const request = new Request({
    method: METHOD,
    endpoint: URL_API,
    headers: {
      ...headers2Use,
    },
    sonda,
    onRedirect: onRedirect || sendToRelogin,
  });

  return request.makeRequest();
};

export default getMyProducts;
